import React, { useState, useRef, useEffect, useContext } from "react";
import Header from "../../components/header";
import { useNavigate } from "react-router-dom";
import { API, baseURL } from "../../services/api";
import axios from "axios";
import AuthContext from "../../components/shared/AuthContext";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import OrgContext from "../../organisation/OrgContext";
import Select from "react-select";
import GoBack from "../../components/goBack";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuthHelper from "../../helpers/AuthHelper";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";

const NewItems = ({ in_popup = false, onSave = () => {} }) => {
  const [t, i18n] = useTranslation();
  const { user, logout } = useContext(AuthContext);
  //const {onlyCommercial} = useAuthHelper();

  let allRequiredInputsAreValid = true;
  const navigate = useNavigate();

  const typeIsMarchandise = useRef();
  const typeIsService = useRef();
  const { organisation, changeOrg } = useContext(OrgContext);

  const nameInputRef = useRef("");

  const buyPriceInputRef = useRef(null);
  const buyPriceAccountInputRef = useRef("");
  const SalesAccountDescription = useRef("");

  const costPriceInputRef = useRef(null);
  const costPriceAccountInputRef = useRef("");
  const purchaseAccountDescription = useRef("");
  const qtyInput = useRef(null);

  const [isNotValid, setIsNotValid] = useState("");
  const [isService, setIsService] = useState(false);
  const [isMarchandise, setIsMarchandise] = useState(true);
  const [typeChecked, setTypeChecked] = useState(true);
  const [units, setUnits] = useState([]);
  const [salesAccounts, setSalesAccounts] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(1);
  const [taxes, setTaxes] = useState([]);
  const [selectedTaxeVente, setSelectedTaxeVente] = useState("");
  const [selectedTaxeAchat, setSelectedTaxeAchat] = useState("");
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const [selectedSalesAccount, setSelectedSalesAccount] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  ////////////////
  const [costPrice, setCostPrice] = useState(0);
  const [buyPrice, setBuyPrice] = useState(0);
  /////////////////
  const [prixInitial, setPrixInitial] = useState(0.0);
  const handleUniteChange = (e) => setSelectedUnit(e.target.value);

  // image
  const [productImagee, setProductImagee] = useState(null); // État pour stocker l'image

  const handleImageChange = (e) => {
    setProductImagee(e.target.files[0]); // Stocker le fichier sélectionné
    console.log("Image sélectionnée :", e.target.files[0]);
  };
  const getUnits = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/units")
      .then((response) => {
        setUnits(response.data.data);
      })
      .catch((error) => console.log("error while retrieving units : " + error));
  };
  const [taxeAchat, setTaxeAchat] = useState([]);
  const [taxeVente, setTaxeVente] = useState([]);

  const getSalesAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/salesaccounts")
      .then((response) => {
        setSalesAccounts(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving setSalesAccounts : " + error)
      );
  };

  const fetchAccounts = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/accounts/${organisation.id}`
    );

    if (response.status === 200) {
      setSalesAccounts(
        response.data.data.filter(
          (account) =>
            account.code !== "34210000" &&
            account.code !== "44110000" &&
            account.code !== "51410000" &&
            account.code !== "51610000"
        )
      );

      setPurchaseAccounts(
        response.data.data.filter(
          (account) =>
            account.code !== "34210000" &&
            account.code !== "44110000" &&
            account.code !== "51410000" &&
            account.code !== "51610000"
        )
      );
    }
  };

  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/purshaseaccounts")
      .then((response) => {
        setPurchaseAccounts(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error)
      );
  };

  const saveProduct = async (formData) => {
    setIsSubmit(true);
    API.post("/product/save", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Indiquer que le contenu est un formulaire multipart
      },
    })
      .then((res) => {
        console.log(res);
        setIsSubmit(false);

        if (!in_popup) {
          Swal.fire(
            t("Le produit a été enregistré avec succès."),
            t(""),
            "success"
          );
          navigate("/items");
        } else {
          onSave();
        }
      })
      .catch((error) => {
        setIsSubmit(false);
        console.log(error);
      });
  };

  const getTaxes = async () => {
    await axios
      .get(baseURL + "/taxes")
      .then((response) => {
        setTaxes(response.data.data);
        setTaxeAchat(
          response.data.data.filter((taxe) => taxe.tax_type === "fournisseur")
        );
        setTaxeVente(
          response.data.data.filter((taxe) => taxe.tax_type === "client")
        );
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error)
      );
  };
  const transformArray = (elt) => {
    let array = [];
    for (let i = 0; i < elt.length; i++) {
      let obj = { value: elt[i].id, label: elt[i].name + " - " + elt[i].code };
      array.push(obj);
    }
    return array;
  };

  useEffect(() => {
    //onlyCommercial();

    getUnits();
    //getSalesAccount();
    //getPurchaseAccount();
    fetchAccounts();
    getTaxes();
  }, []);
  const Save = () => {
    if (checkRequiredInputs()) {
      const formData = new FormData(); // Utiliser FormData pour inclure l'image

      formData.append("type", getSelectedType());
      formData.append("name", nameInputRef.current.value);
      formData.append("unit_id", selectedUnit === null ? 14 : selectedUnit);
      formData.append("sellingPrice", buyPrice);
      formData.append("salesAccount_id", selectedSalesAccount.value);
      formData.append("sellingInfosDescription", SalesAccountDescription.current.value);
      formData.append("costPrice", costPrice);
      formData.append("purchaseAccount_id", selectedPurchaseAccount.value);
      formData.append("purchaseInfosDescription", purchaseAccountDescription.current.value);
      formData.append("user_id", user.id);
      formData.append("qty", Number(qtyInput.current.value).toFixed(2));
      formData.append("prixInitial", prixInitial);
      formData.append("taxevente", selectedTaxeVente.value);
      formData.append("taxeachat", selectedTaxeAchat.value);
      formData.append("organization_id", organisation.id);
      formData.append("depotQuantities", JSON.stringify(depotQuantities)); // Ajouter les quantités par dépôt

      if (productImagee) {
        formData.append("productImage", productImagee); // Ajouter l'image
      }

      saveProduct(formData); // Envoyer le formulaire
    } else {
      toast.error(t("Veuillez remplir tous les champs obligatoires"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const getSelectedType = () => {
    if (typeIsMarchandise.current.checked) {
      return "Marchandise";
    } else if (typeIsService.current.checked) {
      return "Services";
    }
  };

  const isInvalidDomElement = (elementId) => {
    const nomInput = document.getElementById(elementId);
    nomInput.classList.add("is-invalid");
  };
  const isaValidDomElement = (elementId) => {
    const nomInput = document.getElementById(elementId);
    nomInput.classList.remove("is-invalid");
    nomInput.classList.add("is-valid");
  };
  const checkRequiredInputs = () => {
    allRequiredInputsAreValid = true;

    if (nameInputRef.current.value.length <= 0) {
      isInvalidDomElement("nomInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("nomInput");
    }

    if (buyPrice < 0) {
      isInvalidDomElement("buyPriceInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("buyPriceInput");
    }

    if (buyPriceAccountInputRef.current.value == 0) {
      isInvalidDomElement("buyPriceAccountInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("buyPriceAccountInput");
    }

    if (costPrice < 0) {
      isInvalidDomElement("costPriceInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("costPriceInput");
    }

    if (costPriceAccountInputRef.current.value == 0) {
      isInvalidDomElement("costPriceAccountInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("costPriceAccountInput");
    }

    if (qtyInput.current.value < 0) {
      isInvalidDomElement("qtyInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("qtyInput");
    }

    if (!selectedTaxeVente) {
      isInvalidDomElement("taxeVenteInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("taxeVenteInput");
    }

    if (!selectedTaxeAchat) {
      isInvalidDomElement("taxeAchatInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("taxeAchatInput");
    }
    if (prixInitial < 0) {
      isInvalidDomElement("prixInitial");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("prixInitial");
    }
    return allRequiredInputsAreValid;
  };

  // Ajouter un état pour stocker les dépôts et leurs quantités
  const [depots, setDepots] = useState([]);
  const [depotQuantities, setDepotQuantities] = useState({});

  // Fonction pour récupérer les dépôts
  const fetchDepots = async () => {
    try {
      const response = await axios.get(`${baseURL}/depots/${organisation.id}`);
      setDepots(response.data);
      // Initialiser les quantités à 0 pour chaque dépôt
      const initialQuantities = {};
      response.data.forEach((depot) => {
        initialQuantities[depot.id] = 0;
      });
      setDepotQuantities(initialQuantities);
    } catch (error) {
      console.error("Erreur lors de la récupération des dépôts :", error);
    }
  };

  // Appeler fetchDepots dans useEffect
  useEffect(() => {
    fetchDepots();
  }, []);

  // Fonction pour gérer les changements de quantité
  const handleDepotQuantityChange = (depotId, value) => {
    setDepotQuantities((prevQuantities) => ({
      ...prevQuantities,
      [depotId]: value,
    }));
  };

  // Fonction pour calculer la somme des quantités des dépôts
  useEffect(() => {
    const totalQty = Object.values(depotQuantities).reduce(
      (sum, qty) => sum + qty,
      0
    );
    if (qtyInput.current) {
      qtyInput.current.value = totalQty; // Mettre à jour l'input de quantité
    }
  }, [depotQuantities]); // Recalculer à chaque modification des quantités des dépôts

  return (
    <>
      <ToastContainer />
      <div className="main-container container-fluid">
        {!in_popup ? (
          <>
            <GoBack route={"/items/list"} />

            <div className="page-header">
              <h1 className="page-title breadcumpsHeader">{t("Articles")}</h1>
              <div>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => navigate("/items/list")}
                    >
                      {t("Liste des articles")}
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("ajouter un article")}
                  </li>
                </ol>
              </div>
            </div>
          </>
        ) : null}

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">{t("Information générale")}</div>
              </div>
              <div className="card-body">
                <p>
                  {t(
                    "Sélectionnez si cet article est une marchandise physique ou un service que vous offrez"
                  )}
                </p>
                <div className="form-group mg-b-10">
                  <label className="custom-switch ps-0">
                    <input
                      type="checkbox"
                      name="custom-switch-checkbox"
                      className="custom-switch-input"
                      checked={typeChecked}
                      onChange={(e) => {}}
                      onClick={() => {
                        if (buyPriceInputRef.current) {
                          buyPriceInputRef.current.value = ""; // Modifier la propriété value
                        }

                        if (costPriceInputRef.current) {
                          costPriceInputRef.current.value = ""; // Modifier la propriété value
                        }

                        if (qtyInput.current) {
                          qtyInput.current.value = ""; // Modifier la propriété value
                        }

                        setTypeChecked(true);
                        setIsMarchandise(true);
                        setIsService(false);
                      }}
                      ref={typeIsMarchandise}
                    />
                    <span className="custom-switch-indicator me-3"></span>
                    <span className="custom-switch-description mg-l-10">
                      {t("Marchandises")}
                    </span>
                  </label>
                  <br />
                  <label className="custom-switch ps-0">
                    <input
                      type="checkbox"
                      name="custom-switch-checkbox"
                      className="custom-switch-input"
                      checked={!typeChecked}
                      onChange={(e) => {}}
                      onClick={() => {
                        buyPriceInputRef.current.value = 0;
                        costPriceInputRef.current.value = 0;

                        setTypeChecked(!typeChecked);
                        setIsService(true);
                        setIsMarchandise(false);
                        qtyInput.current.value = 1;
                      }}
                      ref={typeIsService}
                    />
                    <span className="custom-switch-indicator me-3"></span>
                    <span className="custom-switch-description mg-l-10">
                      Service
                    </span>
                  </label>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    {t("Intitulé")}{" "}
                    {isMarchandise ? t("de l'article") : t("du service")} *
                  </label>
                  <input
                    type="email"
                    className={`form-control ${isNotValid}`}
                    id="nomInput"
                    placeholder="Nom"
                    ref={nameInputRef}
                  />
                </div>
                {/* // Ajoutez un champ pour télécharger une image dans le
                formulaire */}
                <div className="form-group" style={{
                    display: isService && !isMarchandise ? "none" : "block",
                  }}>
                  <label htmlFor="productImage" className="requiredElt">{t("Image du produit*")}</label>
                  <input
                    type="file"
                    className="form-control"
                    id="productImage"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>
                
                <div
                  className="form-group"
                  style={{
                    display: isService && !isMarchandise ? "none" : "block",
                  }}
                >
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    {t("Unité")}*
                  </label>
                  <div className="input-group mb-3">
                    <select
                      className="form-select"
                      id="inputGroupSelect01"
                      onChange={handleUniteChange}
                    >
                      <option selected value="0">
                        {t("Séléctionnez une unité")}
                      </option>
                      {units.map((unit) => (
                        <option value={unit.id}>{unit.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className="form-group"
                  hidden={isService && !isMarchandise}
                >
                  {/* Bloc des dépôts */}
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">{t("Quantités par dépôt")}</h3>
                    </div>
                    <div className="card-body">
                      {depots.map((depot) => (
                        <div key={depot.id} className="form-group">
                          <label htmlFor={`depot-${depot.id}`}>
                            {t("Dépôt")} : {depot.name}
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id={`depot-${depot.id}`}
                            value={depotQuantities[depot.id]}
                            onChange={(e) =>
                              handleDepotQuantityChange(
                                depot.id,
                                parseFloat(e.target.value) || 0
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Input de quantité */}
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    {t("Quantité total")}*
                  </label>
                  <input
                    type="number"
                    className={`form-control ${isNotValid}`}
                    id="qtyInput"
                    placeholder="la quantité"
                    ref={qtyInput}
                    readOnly // Rendre l'input non cliquable
                    hidden={isService && !isMarchandise}
                  />
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    {t("Prix initial")}*
                  </label>
                  <input
                    type="number"
                    className={`form-control ${isNotValid}`}
                    id="prixInitial"
                    placeholder="prix initial"
                    // value={prixInitial}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value); // Convert string to number
                      if (!isNaN(value)) {
                        setPrixInitial(value.toFixed(2));
                        console.log(prixInitial); // Apply toFixed only on valid number
                      }
                    }}
                    hidden={isService && !isMarchandise}
                  />
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  {t("Informations sur les ventes")}
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div
                      className="form-group"
                      hidden={isService && !isMarchandise}
                    >
                      <label htmlFor="exampleInputname" className="requiredElt">
                        {t("Prix de vente")}*
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          {organisation?.currency?.code}
                        </span>
                        <input
                          type="number"
                          ref={buyPriceInputRef}
                          className={`form-control ${isNotValid}`}
                          aria-label="Amount (to the nearest dollar)"
                          id="buyPriceInput"
                          onChange={(e) => {
                            const value = parseFloat(e.target.value); // Convert string to number
                            if (!isNaN(value)) {
                              setBuyPrice(value.toFixed(2));
                              console.log(buyPrice); // Apply toFixed only on valid number
                            }
                          }}
                          hidden={isService && !isMarchandise}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      isService && !isMarchandise
                        ? "col-lg-12 col-md-12"
                        : "col-lg-6 col-md-12"
                    }
                  >
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputname1"
                        className={`requiredElt`}
                      >
                        {t("Compte")}*
                      </label>
                      <Select
                        ref={buyPriceAccountInputRef}
                        id="buyPriceAccountInput"
                        className={"form-element"}
                        options={transformArray(salesAccounts)}
                        onChange={(choice) => {
                          setSelectedSalesAccount(choice);
                          console.log(
                            "taxe de vente lier au compte: est : ",
                            selectedTaxeAchat
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>{t("Description")}</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    defaultValue=""
                    ref={SalesAccountDescription}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className={`requiredElt`}>
                    {t("Taxe")} *
                  </label>
                  <Select
                    className={`form-element ${isNotValid}`}
                    options={transformArray(taxeVente)}
                    id="taxeVenteInput"
                    onChange={(choice) => {
                      setSelectedTaxeVente(choice);
                      console.log(
                        "taxe de vente lier au compte: est : ",
                        selectedTaxeVente.value
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  {t("Informations sur les achats")}
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div
                    className="col-lg-6 col-md-12"
                    hidden={isService && !isMarchandise}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputname" className="requiredElt">
                        {t("Prix d'achat")} *
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          {organisation?.currency?.code}
                        </span>
                        <input
                          type="number"
                          className={`form-control ${isNotValid}`}
                          aria-label="Amount (to the nearest dollar)"
                          id="costPriceInput"
                          ref={costPriceInputRef}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value); // Convert the string to a number
                            if (!isNaN(value)) {
                              setCostPrice(value.toFixed(2));
                              console.log(costPrice); // Apply toFixed only to valid numbers
                            } else {
                              setCostPrice(""); // Optionnellement, gérer le cas où l'entrée n'est pas un nombre
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      isService && !isMarchandise
                        ? "col-lg-12 col-md-12"
                        : "col-lg-6 col-md-12"
                    }
                  >
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputname1"
                        className={`requiredElt ${isNotValid}`}
                      >
                        {t("Compte")}*
                      </label>
                      <Select
                        ref={costPriceAccountInputRef}
                        id="costPriceAccountInput"
                        className={`form-element ${isNotValid}`}
                        options={transformArray(purchaseAccounts)}
                        onChange={(choice) => {
                          setSelectedPurchaseAccount(choice);
                          console.log("choi: ", choice);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label >{t("Description")}</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    defaultValue=""
                    ref={purchaseAccountDescription}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className={`requiredElt`}>
                    {t("Taxe")} *
                  </label>
                  <Select
                    ref={costPriceAccountInputRef}
                    id="taxeAchatInput"
                    className={`form-element ${isNotValid}`}
                    options={transformArray(taxeAchat)}
                    onChange={(choice) => {
                      setSelectedTaxeAchat(choice);
                    }}
                  />
                </div>
              </div>
              <div className="card-footer">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      type={"button"}
                      disabled={isSubmit}
                      className="btn btn-primary"
                      onClick={Save}
                    >
                      {isSubmit ? t("Loading ...") : t("Enregistrer")}
                    </button>
                    {!in_popup ? (
                      <a
                        onClick={() => {
                          navigate(-1);
                        }}
                        className="btn btn-default float-end"
                      >
                        {t("Annuler")}
                      </a>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {/* 
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">{t("Quantités par dépôt")}</h3>
              </div>
              <div className="card-body">
                {depots.map((depot) => (
                  <div key={depot.id} className="form-group">
                    <label htmlFor={`depot-${depot.id}`}>
                      {t("Dépôt")} : {depot.name}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id={`depot-${depot.id}`}
                      value={depotQuantities[depot.id]}
                      onChange={(e) =>
                        handleDepotQuantityChange(depot.id, parseFloat(e.target.value) || 0)
                      }
                    />
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default NewItems;
